export default "__VITE_ASSET__CbaFjHNj__"